export const GET_STATES = "GET_STATES";
export const GET_CITIES = "GET_CITIES";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_GENRE = "GET_GENRE";
export const GET_SHOWS = "GET_SHOWS";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECT_BY_ID = "GET_PROJECT_BY_ID";
export const GET_ARTISTS = "GET_ARTISTS";
export const GET_ARTIST_BY_ID = "GET_ARTIST_BY_ID";
export const GET_PROJECT_COUNTS = "GET_PROJECT_COUNTS";
export const GET_RBAC = "GET_RBAC";
export const GET_APPFEED = "GET_APPFEED";
export const GET_SYSTEM_CONFIG = "GET_SYSTEM_CONFIG";
export const SET_SYSTEM_CONFIG = "SET_SYSTEM_CONFIG";